import { failureAction, formatNumber } from '../../app-actions';
import { apiGet, apiPost } from '../../api/api-configuration';

import {
  API_INITIATE_GET_AME_CUSTOMER_DATA,
  API_COMPLETE_GET_AME_CUSTOMER_DATA,
  API_END_POINT_ADAPTIVE_MOBILITY_EXTERNAL,
  API_POST_AME_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_SUBMIT_AME_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_AME_CUSTOMER_DATA,
  API_POST_AME_SHOW_DATA_ENDPOINT,
  API_INITIATE_SUBMIT_AME_SHOW_DATA,
  API_COMPLETE_SUBMIT_AME_SHOW_DATA,
  API_POST_AME_TRACKING_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_TRACKING_SUBMIT_AME_CUSTOMER_DATA,
  API_COMPLETE_TRACKING_SUBMIT_AME_CUSTOMER_DATA,
} from '../../app-constants';
import {
  validateEmail,
  validateText,
} from '../ssm-homepage/ssm-homepage.actions';

export const successAdaptiveMobilityExternal = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_GET_AME_CUSTOMER_DATA, data };
};


const getAdaptiveMobilityExternal = data => (dispatch) => {
  const endpoint = `${API_END_POINT_ADAPTIVE_MOBILITY_EXTERNAL}`;
  dispatch({ type: API_INITIATE_GET_AME_CUSTOMER_DATA });
  apiGet(dispatch, endpoint, successAdaptiveMobilityExternal, failureAction, data);
};

export default getAdaptiveMobilityExternal;

export const addedNewObjectInArray = (arrayObject, newobject) => {
  const newArray = [];
  arrayObject.map(el => (
    newArray.push({ ...el, ...newobject })
  ));
  return newArray;
};

export const getTitleChart = (index) => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return letters.charAt(index);
};

export const prepareToggleOptionsArry = (options, id) => {
  const prepareOptions = [];
  options.map((option) => {
    prepareOptions.push({
      label: option.key,
      value: option.value,
      id,
    });
    return prepareOptions;
  });
  return prepareOptions;
};

export const prepareInterestInputFieldsValue = () => {
  const interestInputFieldsValue = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    job: '',
    seniority: '',
    industry: '',
    country: '',
    companySize: '',
    preferredContactTime: '',
    submitCheckbox: false,
  };
  const validateInputFields = {
    firstName: false,
    lastName: false,
    email: false,
    phone: false,
    company: false,
    job: false,
    seniority: false,
    submitCheckbox: false,
  };
  return {
    interestInputFieldsValue,
    validateInputFields,
  };
};

export const prepareDropDownOptionsArry = (options) => {
  const prepareOptions = [];
  options.map((option) => {
    prepareOptions.push({
      displayText: option.value,
      itemId: option.value,
    });
    return prepareOptions;
  });
  return prepareOptions;
};

export const validatePhoneNumberWithStartLetter = (phoneNumber) => {
  const phoneNumberWithoutSpaces = phoneNumber.replace(/[\s]/g, '');
  const regex = /^\(?([0]{1})\)?([23478]{1})([0-9]{8})$/;
  return regex.test(phoneNumberWithoutSpaces);
};


export const validateAllInputFields = (formValue, formError) => {
  let error = false;
  Object.keys(formError).map((fields) => {
    let validateError = false;
    if (fields === 'email') {
      validateError = !validateEmail(formValue[fields]);
    } else if (fields === 'phone') {
      validateError = !validatePhoneNumberWithStartLetter(formValue[fields]);
    } else if (fields === 'firstName' || fields === 'lastName') {
      validateError = !validateText(formValue[fields]);
    } else if (formValue[fields] === '' || formValue[fields] === false) {
      validateError = true;
    }
    if (validateError === true) {
      error = true;
    }
    return validateError;
  });
  return error;
};

export const getDataOnlyPlanRecommendation = (planCost, dataAllowance) => {
  let planName = '';
  if (planCost >= 15 && planCost <= 29 && dataAllowance <= 24) {
    planName = 'mobileBroadBandEssential';
  } else if (planCost >= 15 && planCost <= 29 && dataAllowance > 24 && dataAllowance <= 54) {
    planName = 'mobileBroadBandEnhanced';
  } else if (planCost >= 15 && planCost <= 29 && dataAllowance > 54 && dataAllowance <= 100) {
    planName = 'mobileBroadBandEpic';
  } else if (planCost >= 30 && planCost <= 49 && dataAllowance <= 54) {
    planName = 'mobileBroadBandEnhanced';
  } else if (planCost >= 30 && planCost <= 49 && dataAllowance > 54 && dataAllowance <= 100) {
    planName = 'mobileBroadBandEpic';
  } else if (planCost >= 50 && dataAllowance <= 100) {
    planName = 'mobileBroadBandEpic';
  } else {
    planName = 'mobileBroadBandEssential';
  }
  return planName;
};

export const getVoiceAndDataPlanRecommendation = (planCost, dataAllowance) => {
  let planName = '';
  if (planCost >= 40 && planCost <= 59 && dataAllowance <= 69) {
    planName = 'mobileEssential';
  } else if (planCost >= 40 && planCost <= 59 && dataAllowance > 69 && dataAllowance <= 119) {
    planName = 'mobileEnhanced';
  } else if (planCost >= 40 && planCost <= 59 && dataAllowance > 119 && dataAllowance <= 169) {
    planName = 'mobileEpic';
  } else if (planCost >= 40 && planCost <= 59 && dataAllowance > 169) {
    planName = 'mobileExecutive';
  } else if (planCost >= 60 && planCost <= 69 && dataAllowance <= 119) {
    planName = 'mobileEnhanced';
  } else if (planCost >= 60 && planCost <= 69 && dataAllowance > 119 && dataAllowance <= 169) {
    planName = 'mobileEpic';
  } else if (planCost >= 60 && planCost <= 69 && dataAllowance > 169) {
    planName = 'mobileExecutive';
  } else if (planCost >= 70 && planCost <= 99 && dataAllowance <= 169) {
    planName = 'mobileEpic';
  } else if (planCost >= 70 && planCost <= 99 && dataAllowance > 169) {
    planName = 'mobileExecutive';
  } else {
    planName = 'mobileEssential';
  }
  return planName;
};

export const successActionSubmitAME = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_SUBMIT_AME_CUSTOMER_DATA, data };
};

export const submitAMECalCulatorData = data => (dispatch) => {
  const endpoint = API_POST_AME_CUSTOMER_DATA_ENDPOINT;
  dispatch({ type: API_INITIATE_SUBMIT_AME_CUSTOMER_DATA });
  apiPost(dispatch, endpoint, successActionSubmitAME, failureAction, data);
};


export const successActionSubmitTrackingAME = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_TRACKING_SUBMIT_AME_CUSTOMER_DATA, data };
};

export const submitAMECalculatorTrackingData = data => (dispatch) => {
  const endpoint = API_POST_AME_TRACKING_CUSTOMER_DATA_ENDPOINT;
  dispatch({ type: API_INITIATE_TRACKING_SUBMIT_AME_CUSTOMER_DATA });
  apiPost(dispatch, endpoint, successActionSubmitTrackingAME, failureAction, data);
};

export const validatePlanListData = (planListData) => {
  let isDataValid = true;
  planListData.forEach((planItem) => {
    if (planItem.cost.length === 0 || parseInt(planItem.cost, 10) === 0) {
      isDataValid = false;
    } else if (planItem.dataAllowance.length === 0) {
      isDataValid = false;
    } else if (planItem.numberOfDevices.length === 0 || parseInt(planItem.numberOfDevices, 10) === 0) {
      isDataValid = false;
    }
    return isDataValid;
  });
  return isDataValid;
};

export const prepareShowResultTrackingData = (planListData,
  recommendation,
  beSolutionFound,
  beOptimizedPlans,
  feSolutionFound,
  feOptimizedPlans,
) => {
  let indexcount = 0;
  let currentTotalCost = 0;
  let currentTotalData = 0;
  let recommendedTotalCost = 0;
  let recommendedTotalData = 0;
  let origRecommendedTotalCost = 0;
  let origRecommendedTotalData = 0;
  let optimizationType = '';

  let optimizedPlanDetails = [];

  // fe plans total cost and data
  const finalOptimizedTotalCostInitialValue = 0;
  const finalOptimizedTotalCost = feOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
      (parseInt(recommendation[currentValue.optimizePlanName].voiceCost, 10) * currentValue.totalDevices), finalOptimizedTotalCostInitialValue);

  const finalOptimizedTotalDataInitialValue = 0;
  const finalOptimizedTotalData = feOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
      (parseInt(recommendation[currentValue.optimizePlanName].dataCost, 10) * currentValue.totalDevices), finalOptimizedTotalDataInitialValue);

  // be plans total cost and data
  const backEndOptimizedTotalCostInitialValue = 0;
  const backEndOptimizedTotalCost = beOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
      (parseInt(recommendation[currentValue.planName].voiceCost, 10) * currentValue.devicesCount), backEndOptimizedTotalCostInitialValue);

  const backEndOptimizedTotalDataInitialValue = 0;
  const backEndOptimizedTotalData = beOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
    (parseInt(recommendation[currentValue.planName].dataCost, 10) * currentValue.devicesCount), backEndOptimizedTotalDataInitialValue);


  const planDetails = planListData.map((originalPlan) => {
    const planText = originalPlan.id.split('-')[0];
    const originalPlanId = `${planText} ${getTitleChart(indexcount)}`;
    const planCost = parseInt(originalPlan.cost, 10);
    const planDataAllowance = parseInt(originalPlan.dataAllowance, 10);
    let newPlanName = '';
    if (originalPlan.dataOnly === 'Yes') {
      newPlanName = getDataOnlyPlanRecommendation(planCost, planDataAllowance);
    } else {
      newPlanName = getVoiceAndDataPlanRecommendation(planCost, planDataAllowance);
    }
    indexcount += 1;
    const numberOfDevices = parseInt(originalPlan.numberOfDevices, 10);
    currentTotalCost += planCost * numberOfDevices;
    currentTotalData += planDataAllowance * numberOfDevices;
    origRecommendedTotalCost += parseInt(recommendation[newPlanName].voiceCost, 10) * numberOfDevices;
    origRecommendedTotalData += parseInt(recommendation[newPlanName].dataCost, 10) * numberOfDevices;
    return {
      userPlanName: originalPlanId,
      numberOfDevices,
      cost: planCost,
      data: planDataAllowance,
      dataOnly: originalPlan.dataOnly,
    };
  });

  if (beSolutionFound) {
    optimizationType = 'backend';
    optimizedPlanDetails = beOptimizedPlans.map(plan => (
      {
        numberOfDevices: plan.devicesCount,
        recommendedPlanName: recommendation[plan.planName].title,
        recommendedPlanData: parseInt(recommendation[plan.planName].dataCost, 10),
        recommendedPlanCost: parseInt(recommendation[plan.planName].voiceCost, 10),
      }
    ));
    recommendedTotalCost = backEndOptimizedTotalCost;
    recommendedTotalData = backEndOptimizedTotalData;
  } else if (feSolutionFound) {
    optimizationType = 'frontend';
    optimizedPlanDetails = feOptimizedPlans.map(plan => (
      {
        numberOfDevices: plan.totalDevices,
        recommendedPlanName: recommendation[plan.optimizePlanName].title,
        recommendedPlanData: parseInt(recommendation[plan.optimizePlanName].dataCost, 10),
        recommendedPlanCost: parseInt(recommendation[plan.optimizePlanName].voiceCost, 10),
      }
    ));
    recommendedTotalCost = finalOptimizedTotalCost;
    recommendedTotalData = finalOptimizedTotalData;
  } else {
    optimizationType = 'planbyplan';
    optimizedPlanDetails = planListData.map((originalPlan) => {
      let newPlanName = '';
      const planCost = parseInt(originalPlan.cost, 10);
      const planDataAllowance = parseInt(originalPlan.dataAllowance, 10);
      const numberOfDevices = parseInt(originalPlan.numberOfDevices, 10);
      if (originalPlan.dataOnly === 'Yes') {
        newPlanName = getDataOnlyPlanRecommendation(planCost, planDataAllowance);
      } else {
        newPlanName = getVoiceAndDataPlanRecommendation(planCost, planDataAllowance);
      }
      return {
        numberOfDevices,
        recommendedPlanName: recommendation[newPlanName].title,
        recommendedPlanData: parseInt(recommendation[newPlanName].dataCost, 10),
        recommendedPlanCost: parseInt(recommendation[newPlanName].voiceCost, 10),
      };
    });
    recommendedTotalCost = origRecommendedTotalCost;
    recommendedTotalData = origRecommendedTotalData;
  }

  const recommendedPlans = optimizedPlanDetails.map(optimizePlan => optimizePlan.recommendedPlanName);
  return {
    currentTotalCost,
    currentTotalData,
    recommendedOptimiserLogic: optimizationType,
    recommendedTotalCost,
    recommendedTotalData,
    recommendedPlans,
    planDetails,
    optimizedPlanDetails,
  };
};

export const preparePostCallData = (planListData,
  interestInputFieldsValue,
  recommendation,
  gCaptcha,
  beSolutionFound,
  beOptimizedPlans,
  feSolutionFound,
  feOptimizedPlans,
) => {
  let indexcount = 0;
  let currentTotalCost = 0;
  let currentTotalData = 0;
  let recommendedTotalCost = 0;
  let recommendedTotalData = 0;
  let origRecommendedTotalCost = 0;
  let origRecommendedTotalData = 0;

  let optimizedPlanDetails = [];

  // fe plans total cost and data
  const finalOptimizedTotalCostInitialValue = 0;
  const finalOptimizedTotalCost = feOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
      (parseInt(recommendation[currentValue.optimizePlanName].voiceCost, 10) * currentValue.totalDevices), finalOptimizedTotalCostInitialValue);

  const finalOptimizedTotalDataInitialValue = 0;
  const finalOptimizedTotalData = feOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
      (parseInt(recommendation[currentValue.optimizePlanName].dataCost, 10) * currentValue.totalDevices), finalOptimizedTotalDataInitialValue);

  // be plans total cost and data
  const backEndOptimizedTotalCostInitialValue = 0;
  const backEndOptimizedTotalCost = beOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
      (parseInt(recommendation[currentValue.planName].voiceCost, 10) * currentValue.devicesCount), backEndOptimizedTotalCostInitialValue);

  const backEndOptimizedTotalDataInitialValue = 0;
  const backEndOptimizedTotalData = beOptimizedPlans
    .reduce((accumulator, currentValue) => accumulator +
    (parseInt(recommendation[currentValue.planName].dataCost, 10) * currentValue.devicesCount), backEndOptimizedTotalDataInitialValue);


  const planDetails = planListData.map((originalPlan) => {
    const planText = originalPlan.id.split('-')[0];
    const originalPlanId = `${planText} ${getTitleChart(indexcount)}`;
    const planCost = parseInt(originalPlan.cost, 10);
    const planDataAllowance = parseInt(originalPlan.dataAllowance, 10);
    let newPlanName = '';
    if (originalPlan.dataOnly === 'Yes') {
      newPlanName = getDataOnlyPlanRecommendation(planCost, planDataAllowance);
    } else {
      newPlanName = getVoiceAndDataPlanRecommendation(planCost, planDataAllowance);
    }
    indexcount += 1;
    const numberOfDevices = parseInt(originalPlan.numberOfDevices, 10);
    currentTotalCost += planCost * numberOfDevices;
    currentTotalData += planDataAllowance * numberOfDevices;
    origRecommendedTotalCost += parseInt(recommendation[newPlanName].voiceCost, 10) * numberOfDevices;
    origRecommendedTotalData += parseInt(recommendation[newPlanName].dataCost, 10) * numberOfDevices;
    return {
      userPlanName: originalPlanId,
      numberOfDevices,
      cost: planCost,
      data: planDataAllowance,
      dataOnly: originalPlan.dataOnly,
    };
  });

  if (beSolutionFound) {
    optimizedPlanDetails = beOptimizedPlans.map(plan => (
      {
        numberOfDevices: plan.devicesCount,
        recommendedPlanName: recommendation[plan.planName].title,
        recommendedPlanData: parseInt(recommendation[plan.planName].dataCost, 10),
        recommendedPlanCost: parseInt(recommendation[plan.planName].voiceCost, 10),
      }
    ));
    recommendedTotalCost = backEndOptimizedTotalCost;
    recommendedTotalData = backEndOptimizedTotalData;
  } else if (feSolutionFound) {
    optimizedPlanDetails = feOptimizedPlans.map(plan => (
      {
        numberOfDevices: plan.totalDevices,
        recommendedPlanName: recommendation[plan.optimizePlanName].title,
        recommendedPlanData: parseInt(recommendation[plan.optimizePlanName].dataCost, 10),
        recommendedPlanCost: parseInt(recommendation[plan.optimizePlanName].voiceCost, 10),
      }
    ));
    recommendedTotalCost = finalOptimizedTotalCost;
    recommendedTotalData = finalOptimizedTotalData;
  } else {
    optimizedPlanDetails = planListData.map((originalPlan) => {
      let newPlanName = '';
      const planCost = parseInt(originalPlan.cost, 10);
      const planDataAllowance = parseInt(originalPlan.dataAllowance, 10);
      const numberOfDevices = parseInt(originalPlan.numberOfDevices, 10);
      if (originalPlan.dataOnly === 'Yes') {
        newPlanName = getDataOnlyPlanRecommendation(planCost, planDataAllowance);
      } else {
        newPlanName = getVoiceAndDataPlanRecommendation(planCost, planDataAllowance);
      }
      return {
        numberOfDevices,
        recommendedPlanName: recommendation[newPlanName].title,
        recommendedPlanData: parseInt(recommendation[newPlanName].dataCost, 10),
        recommendedPlanCost: parseInt(recommendation[newPlanName].voiceCost, 10),
      };
    });
    recommendedTotalCost = origRecommendedTotalCost;
    recommendedTotalData = origRecommendedTotalData;
  }

  return {
    firstName: interestInputFieldsValue.firstName,
    lastName: interestInputFieldsValue.lastName,
    businessEmail: interestInputFieldsValue.email,
    phoneNumber: interestInputFieldsValue.phone,
    companyName: interestInputFieldsValue.company,
    jobFunction: interestInputFieldsValue.job,
    seniority: interestInputFieldsValue.seniority,
    industry: interestInputFieldsValue.industry,
    country: interestInputFieldsValue.country,
    companySize: interestInputFieldsValue.companySize,
    preferredContactTime: interestInputFieldsValue.preferredContactTime,
    currentTotalCost,
    currentTotalData,
    recommendedTotalCost,
    recommendedTotalData,
    gCaptchaToken: gCaptcha,
    planDetails,
    optimizedPlanDetails,
  };
};

export const successActionShowAME = (response) => {
  const { data } = response;
  const backendOptimizedAllPlansData = [];
  backendOptimizedAllPlansData.push({
    planName: 'mobileBroadBandEnhanced',
    devicesCount: data.mobileBroadBandEnhanced,
    totalDevicesText: `${data.mobileBroadBandEnhanced} devices`,
  });

  backendOptimizedAllPlansData.push({
    planName: 'mobileBroadBandEpic',
    devicesCount: data.mobileBroadBandEpic,
    totalDevicesText: `${formatNumber(data.mobileBroadBandEpic)} devices`,
  });

  backendOptimizedAllPlansData.push({
    planName: 'mobileBroadBandEssential',
    devicesCount: data.mobileBroadBandEssential,
    totalDevicesText: `${formatNumber(data.mobileBroadBandEssential)} devices`,
  });

  backendOptimizedAllPlansData.push({
    planName: 'mobileEnhanced',
    devicesCount: data.mobileEnhanced,
    totalDevicesText: `${formatNumber(data.mobileEnhanced)} devices`,
  });

  backendOptimizedAllPlansData.push({
    planName: 'mobileEpic',
    devicesCount: data.mobileEpic,
    totalDevicesText: `${formatNumber(data.mobileEpic)} devices`,
  });

  backendOptimizedAllPlansData.push({
    planName: 'mobileEssential',
    devicesCount: data.mobileEssential,
    totalDevicesText: `${formatNumber(data.mobileEssential)} devices`,
  });

  backendOptimizedAllPlansData.push({
    planName: 'mobileExecutive',
    devicesCount: data.mobileExecutive,
    totalDevicesText: `${formatNumber(data.mobileExecutive)} devices`,
  });

  const backendOptimizedPlansWithDevices = backendOptimizedAllPlansData.filter(plans => plans.devicesCount > 0);

  const resultObj = {
    backendOptimizedPlansWithDevices,
    solutionFound: data.solutionFound === 'Yes',
  };

  return { type: API_COMPLETE_SUBMIT_AME_SHOW_DATA, data: resultObj };
};

export const submitAMEShowData = data => (dispatch) => {
  const endpoint = API_POST_AME_SHOW_DATA_ENDPOINT;
  dispatch({ type: API_INITIATE_SUBMIT_AME_SHOW_DATA });
  apiPost(dispatch, endpoint, successActionShowAME, failureAction, data);
};

const furtherOptimizeViewForVoice = (amountAvailable, voiceCostDetails,
  voiceDevices, existingPlan) => {
  const {
    mobileEssVoiceCost,
    mobileEssDataCost,
    mobileEnhVoiceCost,
    mobileEpicVoiceCost,
    mobileExecutiveVoiceCost,
    mobileEnhDataCost,
    mobileEpicDataCost,
    mobileExecutiveDataCost,
  } = voiceCostDetails;

  let optimizeVoicePlan = 'noPlanFound';
  let optimizeVoicePlanCost = 0;
  let optimizeVoicePlanData = 0;
  let existingOptimizeVoicePlanCost = 0;
  let existingOptimizeVoicePlanData = 0;

  let optimizeDevices = 0;
  if (existingPlan === 'mobileEpic' && Math.floor(amountAvailable / (mobileExecutiveVoiceCost - mobileEpicVoiceCost)) > 0) {
    const costDiffExecAndEpic = mobileExecutiveVoiceCost - mobileEpicVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(amountAvailable / costDiffExecAndEpic);
    optimizeDevices = potentialDevicesToBeUpgraded;
    optimizeVoicePlan = 'mobileExecutive';
    optimizeVoicePlanCost = mobileExecutiveVoiceCost * potentialDevicesToBeUpgraded;
    optimizeVoicePlanData = mobileExecutiveDataCost * potentialDevicesToBeUpgraded;
    existingOptimizeVoicePlanCost = mobileEpicVoiceCost * (voiceDevices - potentialDevicesToBeUpgraded);
    existingOptimizeVoicePlanData = mobileEpicDataCost * (voiceDevices - potentialDevicesToBeUpgraded);
  } else if (existingPlan === 'mobileEnhanced' && Math.floor(amountAvailable / (mobileEpicVoiceCost - mobileEnhVoiceCost)) > 0) {
    const costDiffEpicAndEnh = mobileEpicVoiceCost - mobileEnhVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(amountAvailable / costDiffEpicAndEnh);
    optimizeDevices = potentialDevicesToBeUpgraded;
    optimizeVoicePlan = 'mobileEpic';
    optimizeVoicePlanCost = mobileEpicVoiceCost * potentialDevicesToBeUpgraded;
    optimizeVoicePlanData = mobileEpicDataCost * potentialDevicesToBeUpgraded;
    existingOptimizeVoicePlanCost = mobileEnhVoiceCost * (voiceDevices - potentialDevicesToBeUpgraded);
    existingOptimizeVoicePlanData = mobileEnhDataCost * (voiceDevices - potentialDevicesToBeUpgraded);
  } else if (existingPlan === 'mobileEssential' && Math.floor(amountAvailable / (mobileEnhVoiceCost - mobileEssVoiceCost)) > 0) {
    const costDiffEnhAndEss = mobileEnhVoiceCost - mobileEssVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(amountAvailable / costDiffEnhAndEss);
    optimizeDevices = potentialDevicesToBeUpgraded;
    optimizeVoicePlan = 'mobileEnhanced';
    optimizeVoicePlanCost = mobileEnhVoiceCost * potentialDevicesToBeUpgraded;
    optimizeVoicePlanData = mobileEnhDataCost * potentialDevicesToBeUpgraded;
    existingOptimizeVoicePlanCost = mobileEssVoiceCost * (voiceDevices - potentialDevicesToBeUpgraded);
    existingOptimizeVoicePlanData = mobileEssDataCost * (voiceDevices - potentialDevicesToBeUpgraded);
  }

  return {
    optimizeDevices,
    optimizeVoicePlan,
    optimizeVoicePlanCost,
    optimizeVoicePlanData,
    existingOptimizeDevices: voiceDevices - optimizeDevices,
    existingOptimizeVoicePlanCost,
    existingOptimizeVoicePlanData,
  };
};

const furtherOptimizeViewForData = (amountAvailable, dataCostDetails,
  dataDevices, existingPlan) => {
  const {
    mobileBroadBandEssVoiceCost,
    mobileBroadBandEssDataCost,
    mobileBroadBandEnhVoiceCost,
    mobileBroadBandEnhDataCost,
    mobileBroadBandEpicVoiceCost,
    mobileBroadBandEpicDataCost,
  } = dataCostDetails;

  let optimizeDataPlan = 'noPlanFound';
  let optimizeDataPlanCost = 0;
  let optimizeDataPlanData = 0;
  let existingOptimizeDataPlanCost = 0;
  let existingOptimizeDataPlanData = 0;

  let optimizeDevices = 0;
  if (existingPlan === 'mobileBroadBandEnhanced'
    && Math.floor(amountAvailable / (mobileBroadBandEpicVoiceCost - mobileBroadBandEnhVoiceCost)) > 0) {
    const costDiffEpicAndEnh = mobileBroadBandEpicVoiceCost - mobileBroadBandEnhVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(amountAvailable / costDiffEpicAndEnh);
    optimizeDevices = potentialDevicesToBeUpgraded;
    optimizeDataPlan = 'mobileBroadBandEpic';
    optimizeDataPlanCost = mobileBroadBandEpicVoiceCost * potentialDevicesToBeUpgraded;
    optimizeDataPlanData = mobileBroadBandEpicDataCost * potentialDevicesToBeUpgraded;
    existingOptimizeDataPlanCost = mobileBroadBandEnhVoiceCost * (dataDevices - potentialDevicesToBeUpgraded);
    existingOptimizeDataPlanData = mobileBroadBandEnhDataCost * (dataDevices - potentialDevicesToBeUpgraded);
  } else if (existingPlan === 'mobileBroadBandEssential'
    && Math.floor(amountAvailable / (mobileBroadBandEnhVoiceCost - mobileBroadBandEssVoiceCost)) > 0) {
    const costDiffEnhAndEss = mobileBroadBandEnhVoiceCost - mobileBroadBandEssVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(amountAvailable / costDiffEnhAndEss);
    optimizeDevices = potentialDevicesToBeUpgraded;
    optimizeDataPlan = 'mobileBroadBandEnhanced';
    optimizeDataPlanCost = mobileBroadBandEnhVoiceCost * potentialDevicesToBeUpgraded;
    optimizeDataPlanData = mobileBroadBandEnhDataCost * potentialDevicesToBeUpgraded;
    existingOptimizeDataPlanCost = mobileBroadBandEssVoiceCost * (dataDevices - potentialDevicesToBeUpgraded);
    existingOptimizeDataPlanData = mobileBroadBandEssDataCost * (dataDevices - potentialDevicesToBeUpgraded);
  }

  return {
    optimizeDevices,
    optimizeDataPlan,
    optimizeDataPlanCost,
    optimizeDataPlanData,
    existingOptimizeDevices: dataDevices - optimizeDevices,
    existingOptimizeDataPlanCost,
    existingOptimizeDataPlanData,
  };
};

const getOptimizeViewForData = (amountAvailable, dataCostDetails,
  dataDevices) => {
  const {
    mobileBroadBandEssVoiceCost,
    mobileBroadBandEssDataCost,
    mobileBroadBandEnhVoiceCost,
    mobileBroadBandEnhDataCost,
    mobileBroadBandEpicVoiceCost,
    mobileBroadBandEpicDataCost,
  } = dataCostDetails;

  let optimizeDataPlan = 'noPlanFound';
  let optimizeDataPlanCost = 0;
  let optimizeDataPlanData = 0;


  if (amountAvailable > (mobileBroadBandEpicVoiceCost * dataDevices)) {
    optimizeDataPlan = 'mobileBroadBandEpic';
    optimizeDataPlanCost = mobileBroadBandEpicVoiceCost * dataDevices;
    optimizeDataPlanData = mobileBroadBandEpicDataCost * dataDevices;
  } else if (amountAvailable > (mobileBroadBandEnhVoiceCost * dataDevices)) {
    optimizeDataPlan = 'mobileBroadBandEnhanced';
    optimizeDataPlanCost = mobileBroadBandEnhVoiceCost * dataDevices;
    optimizeDataPlanData = mobileBroadBandEnhDataCost * dataDevices;
  } else if (amountAvailable > (mobileBroadBandEssVoiceCost * dataDevices)) {
    optimizeDataPlan = 'mobileBroadBandEssential';
    optimizeDataPlanCost = mobileBroadBandEssVoiceCost * dataDevices;
    optimizeDataPlanData = mobileBroadBandEssDataCost * dataDevices;
  }

  if (optimizeDataPlan === 'noPlanFound') {
    optimizeDataPlan = 'mobileBroadBandEssential';
    optimizeDataPlanCost = mobileBroadBandEssVoiceCost * dataDevices;
    optimizeDataPlanData = mobileBroadBandEssDataCost * dataDevices;
  }

  return {
    optimizeDataPlan,
    optimizeDataPlanCost,
    optimizeDataPlanData,
  };
};


export const getTotalDevices = (currentPlanData) => {
  let voiceDevices = 0;
  let dataDevices = 0;

  const voicePlans = currentPlanData.filter(plan => plan.dataOnly === 'No');
  const dataPlans = currentPlanData.filter(plan => plan.dataOnly === 'Yes');

  voicePlans.forEach((plan) => {
    voiceDevices += parseInt(plan.numberOfDevices, 10);
  });

  dataPlans.forEach((plan) => {
    dataDevices += parseInt(plan.numberOfDevices, 10);
  });

  return voiceDevices + dataDevices;
};

export const getOptimizeView1 = (currentPlanData, recommendationAuthorableContent) => {
  const mobileBroadBandEssVoiceCost = parseInt(recommendationAuthorableContent.mobileBroadBandEssential.voiceCost, 10);
  const mobileBroadBandEssDataCost = parseInt(recommendationAuthorableContent.mobileBroadBandEssential.dataCost, 10);

  const mobileBroadBandEnhVoiceCost = parseInt(recommendationAuthorableContent.mobileBroadBandEnhanced.voiceCost, 10);
  const mobileBroadBandEnhDataCost = parseInt(recommendationAuthorableContent.mobileBroadBandEnhanced.dataCost, 10);

  const mobileBroadBandEpicVoiceCost = parseInt(recommendationAuthorableContent.mobileBroadBandEpic.voiceCost, 10);
  const mobileBroadBandEpicDataCost = parseInt(recommendationAuthorableContent.mobileBroadBandEpic.dataCost, 10);

  const mobileEssVoiceCost = parseInt(recommendationAuthorableContent.mobileEssential.voiceCost, 10);
  const mobileEssDataCost = parseInt(recommendationAuthorableContent.mobileEssential.dataCost, 10);

  const mobileEnhVoiceCost = parseInt(recommendationAuthorableContent.mobileEnhanced.voiceCost, 10);
  const mobileEnhDataCost = parseInt(recommendationAuthorableContent.mobileEnhanced.dataCost, 10);

  const mobileEpicVoiceCost = parseInt(recommendationAuthorableContent.mobileEpic.voiceCost, 10);
  const mobileEpicDataCost = parseInt(recommendationAuthorableContent.mobileEpic.dataCost, 10);

  const mobileExecutiveVoiceCost = parseInt(recommendationAuthorableContent.mobileExecutive.voiceCost, 10);
  const mobileExecutiveDataCost = parseInt(recommendationAuthorableContent.mobileExecutive.dataCost, 10);

  const voicePlans = currentPlanData.filter(plan => plan.dataOnly === 'No');
  const dataPlans = currentPlanData.filter(plan => plan.dataOnly === 'Yes');

  let totalVoicePlansVoiceCost = 0;
  let totalDataPlansVoiceCost = 0;

  let voiceDevices = 0;
  let dataDevices = 0;

  let availableSpend = 0;
  let moneyUsed = 0;
  let totalDataAvailableInOptimizePlan = 0;

  let optimizeDataPlan = 'noPlanFound';
  let optimizeVoicePlan = 'noPlanFound';

  const finalOptimizedPlans = [];

  voicePlans.forEach((plan) => {
    voiceDevices += parseInt(plan.numberOfDevices, 10);
  });

  dataPlans.forEach((plan) => {
    dataDevices += parseInt(plan.numberOfDevices, 10);
  });

  voicePlans.forEach((plan) => {
    totalVoicePlansVoiceCost += parseInt(plan.cost, 10) * parseInt(plan.numberOfDevices, 10);
  });

  dataPlans.forEach((plan) => {
    totalDataPlansVoiceCost += parseInt(plan.cost, 10) * parseInt(plan.numberOfDevices, 10);
  });

  if (dataDevices === 0) { // only mobile plans
    const totalAvailableCost = totalVoicePlansVoiceCost + totalDataPlansVoiceCost;
    if (totalAvailableCost > (mobileExecutiveVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileExecutiveVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileExecutive';
      moneyUsed = mobileExecutiveVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileExecutiveDataCost * voiceDevices;
    } else if (totalAvailableCost > (mobileEpicVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileEpicVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileEpic';
      moneyUsed = mobileEpicVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileEpicDataCost * voiceDevices;
    } else if (totalAvailableCost > (mobileEnhVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileEnhVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileEnhanced';
      moneyUsed = mobileEnhVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileEnhDataCost * voiceDevices;
    } else if (totalAvailableCost > (mobileEssVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileEssVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileEssential';
      moneyUsed = mobileEssVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileEssDataCost * voiceDevices;
    } else {
      availableSpend = totalAvailableCost - (mobileEssVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileEssential';
      moneyUsed = mobileEssVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileEssDataCost * voiceDevices;
    }

    // further optimization if possible
    const voiceCostDetails = {
      mobileEssVoiceCost,
      mobileEnhVoiceCost,
      mobileEpicVoiceCost,
      mobileExecutiveVoiceCost,
      mobileEssDataCost,
      mobileEnhDataCost,
      mobileEpicDataCost,
      mobileExecutiveDataCost,
    };
    const furtherOptimizeDetails = furtherOptimizeViewForVoice(availableSpend,
      voiceCostDetails, voiceDevices, optimizeVoicePlan);
    if (furtherOptimizeDetails.optimizeVoicePlan !== 'noPlanFound') {
      finalOptimizedPlans.push({
        planTitle: `${formatNumber(furtherOptimizeDetails.existingOptimizeDevices)} devices`,
        planName: optimizeVoicePlan,
        planDevices: furtherOptimizeDetails.existingOptimizeDevices,
        planVoiceCost: furtherOptimizeDetails.existingOptimizeVoicePlanCost,
        planDataCost: furtherOptimizeDetails.existingOptimizeVoicePlanData,
      });
      finalOptimizedPlans.push({
        planTitle: `${formatNumber(furtherOptimizeDetails.optimizeDevices)} devices`,
        planName: furtherOptimizeDetails.optimizeVoicePlan,
        planDevices: furtherOptimizeDetails.optimizeDevices,
        planVoiceCost: furtherOptimizeDetails.optimizeVoicePlanCost,
        planDataCost: furtherOptimizeDetails.optimizeVoicePlanData,
      });
    } else {
      finalOptimizedPlans.push({
        planTitle: `${formatNumber(voiceDevices)} devices`,
        planName: optimizeVoicePlan,
        planDevices: voiceDevices,
        planVoiceCost: moneyUsed,
        planDataCost: totalDataAvailableInOptimizePlan,
      });
    }
  } else if (voiceDevices === 0) { // only broadband devices
    const totalAvailableCost = totalVoicePlansVoiceCost + totalDataPlansVoiceCost;
    if (totalAvailableCost > (mobileBroadBandEpicVoiceCost * dataDevices)) {
      availableSpend = totalAvailableCost - (mobileBroadBandEpicVoiceCost * dataDevices);
      optimizeDataPlan = 'mobileBroadBandEpic';
      moneyUsed = mobileBroadBandEpicVoiceCost * dataDevices;
      totalDataAvailableInOptimizePlan = mobileBroadBandEpicDataCost * dataDevices;
    } else if (totalAvailableCost > (mobileBroadBandEnhVoiceCost * dataDevices)) {
      availableSpend = totalAvailableCost - (mobileBroadBandEnhVoiceCost * dataDevices);
      optimizeDataPlan = 'mobileBroadBandEnhanced';
      moneyUsed = mobileBroadBandEnhVoiceCost * dataDevices;
      totalDataAvailableInOptimizePlan = mobileBroadBandEnhDataCost * dataDevices;
    } else if (totalAvailableCost > (mobileBroadBandEssVoiceCost * dataDevices)) {
      availableSpend = totalAvailableCost - (mobileBroadBandEssVoiceCost * dataDevices);
      optimizeDataPlan = 'mobileBroadBandEssential';
      moneyUsed = mobileBroadBandEssVoiceCost * dataDevices;
      totalDataAvailableInOptimizePlan = mobileBroadBandEssDataCost * dataDevices;
    } else {
      availableSpend = totalAvailableCost - (mobileBroadBandEssVoiceCost * dataDevices);
      optimizeDataPlan = 'mobileBroadBandEssential';
      moneyUsed = mobileBroadBandEssVoiceCost * dataDevices;
      totalDataAvailableInOptimizePlan = mobileBroadBandEssDataCost * dataDevices;
    }

    const dataCostDetails = {
      mobileBroadBandEssVoiceCost,
      mobileBroadBandEssDataCost,
      mobileBroadBandEnhVoiceCost,
      mobileBroadBandEnhDataCost,
      mobileBroadBandEpicVoiceCost,
      mobileBroadBandEpicDataCost,
    };

    // further optimization if possible
    const furtherOptimizeDetails = furtherOptimizeViewForData(availableSpend,
      dataCostDetails, dataDevices, optimizeDataPlan);
    if (furtherOptimizeDetails.optimizeDataPlan !== 'noPlanFound') {
      finalOptimizedPlans.push({
        planTitle: `${formatNumber(furtherOptimizeDetails.existingOptimizeDevices)} devices`,
        planName: optimizeDataPlan,
        planDevices: furtherOptimizeDetails.existingOptimizeDevices,
        planVoiceCost: furtherOptimizeDetails.existingOptimizeDataPlanCost,
        planDataCost: furtherOptimizeDetails.existingOptimizeDataPlanData,
      });
      finalOptimizedPlans.push({
        planTitle: `${formatNumber(furtherOptimizeDetails.optimizeDevices)} devices`,
        planName: furtherOptimizeDetails.optimizeDataPlan,
        planDevices: furtherOptimizeDetails.optimizeDevices,
        planVoiceCost: furtherOptimizeDetails.optimizeDataPlanCost,
        planDataCost: furtherOptimizeDetails.optimizeDataPlanData,
      });
    } else {
      finalOptimizedPlans.push({
        planTitle: `${formatNumber(dataDevices)} devices`,
        planName: optimizeDataPlan,
        planDevices: dataDevices,
        planVoiceCost: moneyUsed,
        planDataCost: totalDataAvailableInOptimizePlan,
      });
    }
  } else { // both mobile and broadband plans
    // first voice plans

    const totalAvailableCost = totalVoicePlansVoiceCost + totalDataPlansVoiceCost;
    if (totalAvailableCost > (mobileExecutiveVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileExecutiveVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileExecutive';
      moneyUsed = mobileExecutiveVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileExecutiveDataCost * voiceDevices;
    } else if (totalAvailableCost > (mobileEpicVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileEpicVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileEpic';
      moneyUsed = mobileEpicVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileEpicDataCost * voiceDevices;
    } else if (totalAvailableCost > (mobileEnhVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileEnhVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileEnhanced';
      moneyUsed = mobileEnhVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileEnhDataCost * voiceDevices;
    } else if (totalAvailableCost > (mobileEssVoiceCost * voiceDevices)) {
      availableSpend = totalAvailableCost - (mobileEssVoiceCost * voiceDevices);
      optimizeVoicePlan = 'mobileEssential';
      moneyUsed = mobileEssVoiceCost * voiceDevices;
      totalDataAvailableInOptimizePlan = mobileEssDataCost * voiceDevices;
    }

    const dataCostDetails = {
      mobileBroadBandEssVoiceCost,
      mobileBroadBandEssDataCost,
      mobileBroadBandEnhVoiceCost,
      mobileBroadBandEnhDataCost,
      mobileBroadBandEpicVoiceCost,
      mobileBroadBandEpicDataCost,
    };

    const optimizeDataDetails = getOptimizeViewForData(availableSpend, dataCostDetails, dataDevices);

    if (availableSpend - optimizeDataDetails.optimizeDataPlanCost > 0 &&
      optimizeVoicePlan !== 'mobileExecutive') { // some money available
      // first try to optimize voice plans
      const voiceCostDetails = {
        mobileEssVoiceCost,
        mobileEnhVoiceCost,
        mobileEpicVoiceCost,
        mobileEssDataCost,
        mobileEnhDataCost,
        mobileEpicDataCost,
        mobileExecutiveVoiceCost,
        mobileExecutiveDataCost,
      };
      const newAvailableSpend = availableSpend - optimizeDataDetails.optimizeDataPlanCost;
      const furtherOptimizeVoiceDetails = furtherOptimizeViewForVoice(newAvailableSpend,
        voiceCostDetails, voiceDevices, optimizeVoicePlan);
      if (furtherOptimizeVoiceDetails.optimizeVoicePlan !== 'noPlanFound') {
        finalOptimizedPlans.push({
          planTitle: `${formatNumber(furtherOptimizeVoiceDetails.existingOptimizeDevices)} devices`,
          planName: optimizeVoicePlan,
          planDevices: furtherOptimizeVoiceDetails.existingOptimizeDevices,
          planVoiceCost: furtherOptimizeVoiceDetails.existingOptimizeVoicePlanCost,
          planDataCost: furtherOptimizeVoiceDetails.existingOptimizeVoicePlanData,
        });
        finalOptimizedPlans.push({
          planTitle: `${formatNumber(furtherOptimizeVoiceDetails.optimizeDevices)} devices`,
          planName: furtherOptimizeVoiceDetails.optimizeVoicePlan,
          planDevices: furtherOptimizeVoiceDetails.optimizeDevices,
          planVoiceCost: furtherOptimizeVoiceDetails.optimizeVoicePlanCost,
          planDataCost: furtherOptimizeVoiceDetails.optimizeVoicePlanData,
        });
      } else {
        finalOptimizedPlans.push({
          planTitle: `${formatNumber(voiceDevices)} devices`,
          planName: optimizeVoicePlan,
          planDevices: voiceDevices,
          planVoiceCost: moneyUsed,
          planDataCost: totalDataAvailableInOptimizePlan,
        });
      }

      const finalOptimizedTotalCostInitialValue = 0;
      const finalOptimizedTotalCost = finalOptimizedPlans
        .reduce((accumulator, currentValue) => accumulator + currentValue.planVoiceCost, finalOptimizedTotalCostInitialValue);

      const furtherRemainingMoney = totalAvailableCost - optimizeDataDetails.optimizeDataPlanCost - finalOptimizedTotalCost;


      if (furtherRemainingMoney > 0 &&
        optimizeDataDetails.optimizeDataPlan !== 'mobileBroadBandEpic') { // if still money available go for optimization for data
        const furtherOptimizeDataDetails = furtherOptimizeViewForData(furtherRemainingMoney,
          dataCostDetails, dataDevices, optimizeDataDetails.optimizeDataPlan);
        if (furtherOptimizeDataDetails.optimizeDataPlan !== 'noPlanFound') {
          finalOptimizedPlans.push({
            planTitle: `${formatNumber(furtherOptimizeDataDetails.existingOptimizeDevices)} devices`,
            planName: optimizeDataDetails.optimizeDataPlan,
            planDevices: furtherOptimizeDataDetails.existingOptimizeDevices,
            planVoiceCost: furtherOptimizeDataDetails.existingOptimizeDataPlanCost,
            planDataCost: furtherOptimizeDataDetails.existingOptimizeDataPlanData,
          });
          finalOptimizedPlans.push({
            planTitle: `${formatNumber(furtherOptimizeDataDetails.optimizeDevices)} devices`,
            planName: furtherOptimizeDataDetails.optimizeDataPlan,
            planDevices: furtherOptimizeDataDetails.optimizeDevices,
            planVoiceCost: furtherOptimizeDataDetails.optimizeDataPlanCost,
            planDataCost: furtherOptimizeDataDetails.optimizeDataPlanData,
          });
        } else {
          finalOptimizedPlans.push({
            planTitle: `${formatNumber(dataDevices)} devices`,
            planName: optimizeDataDetails.optimizeDataPlan,
            planDevices: dataDevices,
            planVoiceCost: optimizeDataDetails.optimizeDataPlanCost,
            planDataCost: optimizeDataDetails.optimizeDataPlanData,
          });
        }
      } else { // cannot further optimize data plans
        finalOptimizedPlans.push({
          planTitle: `${formatNumber(dataDevices)} devices`,
          planName: optimizeDataDetails.optimizeDataPlan,
          planDevices: dataDevices,
          planVoiceCost: optimizeDataDetails.optimizeDataPlanCost,
          planDataCost: optimizeDataDetails.optimizeDataPlanData,
        });
      }
    } else {
      finalOptimizedPlans.push({
        planTitle: `${formatNumber(voiceDevices)} devices`,
        planName: optimizeVoicePlan,
        planDevices: voiceDevices,
        planVoiceCost: moneyUsed,
        planDataCost: totalDataAvailableInOptimizePlan,
      });

      const furtherRemainingMoney = availableSpend - optimizeDataDetails.optimizeDataPlanCost;

      if (furtherRemainingMoney > 0 &&
        optimizeDataDetails.optimizeDataPlan !== 'mobileBroadBandEpic') { // if still money available go for optimization for data
        const furtherOptimizeDataDetails = furtherOptimizeViewForData(furtherRemainingMoney,
          dataCostDetails, dataDevices, optimizeDataDetails.optimizeDataPlan);
        if (furtherOptimizeDataDetails.optimizeDataPlan !== 'noPlanFound') {
          finalOptimizedPlans.push({
            planTitle: `${formatNumber(furtherOptimizeDataDetails.existingOptimizeDevices)} devices`,
            planName: optimizeDataDetails.optimizeDataPlan,
            planDevices: furtherOptimizeDataDetails.existingOptimizeDevices,
            planVoiceCost: furtherOptimizeDataDetails.existingOptimizeDataPlanCost,
            planDataCost: furtherOptimizeDataDetails.existingOptimizeDataPlanData,
          });
          finalOptimizedPlans.push({
            planTitle: `${formatNumber(furtherOptimizeDataDetails.optimizeDevices)} devices`,
            planName: furtherOptimizeDataDetails.optimizeDataPlan,
            planDevices: furtherOptimizeDataDetails.optimizeDevices,
            planVoiceCost: furtherOptimizeDataDetails.optimizeDataPlanCost,
            planDataCost: furtherOptimizeDataDetails.optimizeDataPlanData,
          });
        } else {
          finalOptimizedPlans.push({
            planTitle: `${formatNumber(dataDevices)} devices`,
            planName: optimizeDataDetails.optimizeDataPlan,
            planDevices: dataDevices,
            planVoiceCost: optimizeDataDetails.optimizeDataPlanCost,
            planDataCost: optimizeDataDetails.optimizeDataPlanData,
          });
        }
      } else {
        finalOptimizedPlans.push({
          planTitle: `${formatNumber(dataDevices)} devices`,
          planName: optimizeDataDetails.optimizeDataPlan,
          planDevices: dataDevices,
          planVoiceCost: optimizeDataDetails.optimizeDataPlanCost,
          planDataCost: optimizeDataDetails.optimizeDataPlanData,
        });
      }
    }
  }

  return {
    finalOptimizedPlans,
    solutionFound: finalOptimizedPlans.every(plan => plan.planName !== 'noPlanFound'),
  };
};

